import { SearchResultCategory } from '@/types/graphql';

export const SEARCH_SUGGESTIONS = [
  'How do I hit my quota?',
  'Should I send a thank you note after an interview?',
  'Find Sahil Mansuri',
  'What is it like working for Gong?',
  'What can Bravado do for me?',
];

export const HISTORY_ITEMS_LIMIT = 5;

export const SEARCH_CATEGORY_SLUGS_MAP = new Map<SearchResultCategory, string>([
  [SearchResultCategory.AcademyArticles, 'articles'],
  [SearchResultCategory.Companies, 'companies'],
  [SearchResultCategory.Pages, 'pages'],
  [SearchResultCategory.UserPortfolios, 'people'],
  [SearchResultCategory.WrComments, 'comments'],
  [SearchResultCategory.WrPosts, 'posts'],
  [SearchResultCategory.WrUsers, 'users'],
  [SearchResultCategory.Content, 'content'],
]);

export const CONTENT_CATEGORY_SLUGS: SearchResultCategory[] = [
  SearchResultCategory.AcademyArticles,
  SearchResultCategory.WrPosts,
  SearchResultCategory.Pages,
];
